import { TableCell } from "@material-ui/core"
import { Collection } from "@type-r/models"
import { asCurrency, div, FormValue, InlineTable, TableHeader, TableRow } from "lqx-react"
import React from "react"
import { PolicyBuyerSchedule } from "../../../api/policy"

export const PolicyStoredBuyersTable = ({ buyers }: { buyers: Collection<PolicyBuyerSchedule> }) => {
    return (
        <TableContainer>
            <InlineTable noBorders>
                <TableHeader>
                    <TableCell>BUYER NAME</TableCell>
                    <TableCell>DUNS #</TableCell>
                    <TableCell>BUYER COUNTRY</TableCell>
                    <TableCell>MAX CREDIT LIMIT</TableCell>
                    <TableCell>STATE</TableCell>
                </TableHeader>
                {buyers.map(buyer =>
                    <TableRow key={buyer.cid}>
                        <TableCell>
                            <FormValue>{buyer.buyerName}</FormValue>
                        </TableCell>
                        <TableCell>
                            <FormValue>{buyer.buyerDUNS}</FormValue>
                        </TableCell>
                        <TableCell>
                            <FormValue>{buyer.obligor.address.countryCode}</FormValue>
                        </TableCell>
                        <TableCell>
                            <FormValue>{asCurrency(buyer.maxCreditLimit)}</FormValue>
                        </TableCell>
                        <TableCell>
                            <FormValue>{buyer.state}</FormValue>
                        </TableCell>
                    </TableRow>
                )}
            </InlineTable>
        </TableContainer >)
}

const TableContainer = div({
    marginTop: '45px',
    marginLeft: '45px',
    marginRight: '45px'
});
